/// <amd-module name="Repos/Views/Settings/Repositories/Components/AccountRepositories" />
import * as React from "react";
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { PerformanceScenario } from "VSS/Platform/Components/Performance";
import { Components, WrappedComponent } from "VSS/Platform/Layout";
import { Header, TitleSize } from "VSSUI/Header";
import { Page } from "VSSUI/Page";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { Surface, SurfaceBackground } from "VSSUI/Surface";

function AccountRepositories() {
    return (
        <PerformanceScenario area="Repos" scenarioName="account-repositories-settings" tti={true}>
            <Surface background={SurfaceBackground.neutral}>
                <Page className="flex-grow">
                    <Header titleSize={TitleSize.Large} title={Resources.AllRepositories} />
                    <div className="page-content page-content-top">
                        <WrappedComponent
                            loadingComponent={() => <Spinner size={SpinnerSize.large} />}
                            dependencies={["ms.vss-code-web.settings-options"]}
                            wrappedProps={{ projectId: "" }}
                            wrappedType="ms.vss-code-web.settings-options-component"
                        />
                    </div>
                </Page>
            </Surface>
        </PerformanceScenario>
    );
}

Components.add("account-repositories-settings-component", AccountRepositories);
